<template>
    <div>
        <div class="title" :class="{green_background:greenBackground}">
            <p>{{ title }}</p>
        </div>
        <div class="video">
            <iframe :src="link" frameborder="0" allowfullscreen></iframe>
        </div>
    </div>
</template>
<script>
    import {BModal} from 'bootstrap-vue'
    export default {
        components:{
            BModal
        },
        props:{
            title:{
                type:String,
                default:'Video Title'
            },
            link:{
                type:String,
                default:''    
            },
            greenBackground:{
                type:Boolean,
                default:false
            }
        },
       
    }
</script>
<style scoped>
.title{
    background: #e9eaec ;
    padding: 15px 10px;
    margin-bottom: 10px;
    color: #525778;
    border-radius: 3px;
    text-align: left;
}
.title p{
    color: #525778;
    font-weight: bold;
    font-size: 14px;
}
iframe{
    width: 100%;
    height: 205px;
}
.green_background{
    background:#96f5dd;
}
@media(max-width: 1200px){
    iframe{
        height: 360px;
    }
}
@media(min-width: 2560px){
    iframe{
        height: 300px;
    }
}
</style>>
    
